var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { mixpanelTracking } from '@/services/mixpanel';
import { getVideosCRM } from '@/shared/utils/Infosets.utils';
import { getHubspotAuthenticationUri } from '@/clients/crm';
import Modal from 'components/Modal.vue';
import Tooltip from 'components/Tooltip.vue';
import CrmCardContent from 'components/CrmCardContent.vue';
import { NotificationService } from '@/services/NotificationService';
let HubSpotConfigCard = class HubSpotConfigCard extends Vue {
    constructor() {
        super(...arguments);
        this.openModal = false;
        this.waiting = false;
        this.crmIcon = 'statics/images/logos/hubspot-logo.png';
        this.companyFields = [
            'Razão Social',
            'Nome Fantasia',
            'Estado',
            'CNPJ',
            'Cidade',
            'CEP',
            'Endereço',
            'País',
            'Website',
            'Setor',
            'Origem',
            'Data de Abertura',
            'Capital Social',
            'Faixa de Faturamento da Unidade CNPJ',
            'Faixa de Funcionários da Unidade CNPJ',
            'Todos os Telefones',
            'Todos os Emails',
            'Emails Válidos',
            'Página da Empresa no Facebook',
            'Outras Informações',
            'Decisores',
            'Telefones Principais',
            'Emails Principais',
        ];
        this.decisorFields = [
            'Nome',
            'Empresa',
            'Nível de decisão',
            'E-mail',
            'Link do linkedIn',
        ];
        this.questions = [
            {
                question: 'Quais planos permitem exportação?',
                answer: 'Todos',
            },
            {
                question: 'Qual nível de permissão meu usuário precisa ter?',
                answer: 'Superadministrador ou usuário que possa criar e editar empresas e contatos.',
            },
            {
                question: 'Onde encontrar os dados das empresas?',
                answer: 'No menu lateral esquerdo vai em CRM e depois em Empresas.',
            },
            {
                question: 'Onde encontrar os dados dos decisores?',
                answer: 'No menu lateral esquerdo vai em CRM e depois em Contatos.',
            },
            {
                question: 'O que acontece se eu exportar 2 vezes a mesma empresa?',
                answer: 'Nosso integrador irá atualizar os dados da empresa baseado no campo de cnpj e os contatos baseado no campo linkedin e email.',
            },
        ];
    }
    get tutorialVideoLink() {
        return getVideosCRM('hubspot');
    }
    async handleBtnClick() {
        this.waiting = true;
        try {
            const redirect_uri = `${window.location.origin}/crm/hubspot/callback`;
            const response = await getHubspotAuthenticationUri({ redirect_uri });
            window.open(response.data.uri, 'popup', 'height=600,width=400');
            mixpanelTracking('integrações: Configuração com Hubspot iniciada');
        }
        catch (e) {
            NotificationService.error('Error', 'Não foi possível gerar a janela de autenticação');
        }
        this.waiting = false;
    }
};
HubSpotConfigCard = __decorate([
    Component({
        name: 'HubSpotConfigCard',
        components: {
            Modal,
            Tooltip,
            CrmCardContent,
        },
    })
], HubSpotConfigCard);
export default HubSpotConfigCard;
